import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_equip_materials_maternal_healthcare_medical_fac_clinic'

export const dataPointDefinition = {
  retracedId: 'no_equip_materials_maternal_healthcare_medical_fac_clinic',
  name: 'No equipment/ materials for maternal healthcare in medical facilities/clinic(s)',
  description: 'Maternal health refers to the health of women during pregnancy, childbirth and the postpartum period. ',
  meta: {
    slcpMeta: {
      key: 'hs-fir-37x',
      number: 'HS-FIR-6-5',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-fir-32',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-fir-30,Yes;No;No applicable legal requirements',
      machineShowHide: '[2],hs-fir-30,1;2;4',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-fir-37x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31090,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
